import type { PrivateEventDetail } from '../../api/privateEvents';

import NotRecordedPill from './NotRecordedPill';

export default function PersonValue({
  person,
  field,
  migrated,
}: {
  person: PrivateEventDetail['owner'];
  field: string;
  migrated: boolean;
}) {
  if (person) return <>{person.name}</>;
  return migrated ? <NotRecordedPill field={field} short /> : <>—</>;
}
